export default __webpack_public_path__ + "static/media/bg-form.1ab05949.jpg";